import { Panel as CXPanel } from '@sanlamcx/react-ui-next-panel';

export type Panel = CXPanel;
export const Panel = CXPanel;
